export default "__VITE_ASSET__C89xBTW7__"